export const ServiceStatusEnum = {
    'NOT_OPENED': 0, // 已关闭
    'TRIAL_OPEN': 1, // 已开通
    'FORMAL_OPEN': 2, // 已开通
    'TRIAL_EXPIRED_OR_INSUFFICIENT': 3, // 试用过期
    'FORMAL_EXPIRED_OR_INSUFFICIENT': 4, // 正式过期
    'FORMAL_POST_PAY_EXPIRED': 5, // 试用余量不足
};
